<template>
	<path d="M10 4V10M10 16V10M10 10H4M10 10H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</template>
